import React from "react";

// Self-contained Bahasa-first i18n for Front Desk v2 (decoupled from the HGS LanguageProvider, which
// defaults to English and carries guest-domain strings). Default "id"; persists to "frontdesk-language".
const STRINGS = {
  id: {
    app_name: "Front Desk",
    nav_rack: "Peta Kamar",
    rack_title: "Peta Kamar",
    rack_subtitle: "Lihat status semua kamar untuk tanggal terpilih.",
    view_compact: "Padat",
    view_detailed: "Detail",
    date: "Tanggal",
    today: "Hari ini",
    today_current_hint: "Filter tanggal sedang di hari ini.",
    today_jump_hint: "Kembali ke hari ini.",
    building: "Gedung",
    all_buildings: "Semua gedung",
    floor: "Lantai",
    legend: "Keterangan",
    guest: "Tamu",
    open_booking: "Buka booking",
    reserved: "Reserved",
    available: "Available",
    blocked: "Blocked",
    loading: "Memuat…",
    empty_rooms: "Tidak ada kamar untuk filter ini.",
    error_title: "Gagal memuat",
    error_body: "Terjadi masalah. Coba muat ulang halaman.",
    retry: "Coba lagi",
    rooms_count: "kamar",
    status_vacant_clean: "Vacant Clean",
    status_vacant_dirty: "Vacant Dirty",
    status_occupied_dirty: "Occupied Dirty",
    status_maintenance: "Maintenance",
    legend_physical: "Status kamar",
    legend_booking: "Status tanggal",
    legend_activity: "Aktivitas",
    caption_room: "Kamar",
    transit: "Transit",
    transit_continues: "berlanjut besok s/d",
    transit_continued: "lanjutan, mulai kemarin",
    late_until: "Late s/d",
    transit_overdue: "Lewat waktu",
    transit_crosses_midnight: "lintas tengah malam",
    legend_transit: "Transit (sewa per jam)",
    transit_today: "Transit hari ini",
    daypart_dini_hari: "Dini hari",
    daypart_pagi: "Pagi",
    daypart_siang: "Siang",
    daypart_sore: "Sore",
    daypart_malam: "Malam",
    transit_past_ended:
      "Slot ini sudah berakhir hari ini. Cek lagi jamnya — 21:00 adalah malam, 09:00 adalah pagi.",
    transit_past_started:
      "Slot ini sudah berjalan. Cek lagi jamnya — 21:00 adalah malam, 09:00 adalah pagi.",
    transit_hours: "jam",
    caption_date: "Tanggal",
    actions: "Aksi",
    change_status: "Ubah status kamar",
    request_reopen: "Ajukan reopen",
    confirm_reopen: "Ajukan permintaan reopen untuk kamar ini?",
    reopen_why: "Belum bisa diajukan:",
    reopen_ready: "Kamar siap diajukan reopen.",
    reopen_pick_title: "Pilih kamar untuk reopen",
    reopen_pick_intro:
      "Ada lebih dari satu tamu yang keluar di kamar ini. Pilih tamu/tanggal yang malamnya akan dilepas kembali ke ketersediaan.",
    reopen_nights: "malam",
    crit_has_reservation: "Ada reservasi pada tanggal ini",
    crit_stay_started: "Tamu sudah check-in/out",
    crit_no_pending_reopen: "Belum ada permintaan reopen",
    crit_room_still_reserved: "Ketersediaan kamar masih aktif",
    status_current_hint: "Status saat ini",
    block_room: "Blokir kamar",
    unblock_room: "Buka blokir",
    confirm_block: "Blokir kamar ini untuk tanggal terpilih?",
    confirm_unblock: "Buka blokir kamar ini untuk tanggal terpilih?",
    nav_today: "Beranda",
    today_title: "Beranda",
    today_subtitle: "Ringkasan operasional hari ini.",
    c_arrivals: "Check In",
    c_departures: "Check Out",
    c_in_house: "Menginap",
    c_guests: "tamu menginap",
    c_to_clean: "Perlu dibersihkan",
    arrivals_today: "Check-in hari ini",
    departures_today: "Check-out hari ini",
    none_here: "Tidak ada data.",
    checkin_action: "Check-in",
    checkout_action: "Check-out",
    manual_checkin_action: "Check-in manual",
    manual_checkout_action: "Check-out manual",
    confirm_manual_checkin:
      "Lakukan CHECK-IN MANUAL untuk tamu ini? Biasanya tamu check-in sendiri di mesin SelfQ — pakai ini hanya bila memang diperlukan.",
    confirm_manual_checkout:
      "Lakukan CHECK-OUT MANUAL untuk tamu ini? Biasanya check-out dilakukan di mesin SelfQ — pakai ini hanya bila memang diperlukan.",
    confirm_cancel: "Batalkan",
    confirm_checkin_title: "Check-in manual dari FO?",
    confirm_checkin_body:
      "Check-in biasanya dilakukan tamu sendiri di mesin selfq. Lakukan check-in manual hanya sebagai bantuan bila tamu tidak dapat menggunakan mesin.",
    confirm_checkin_ok: "Ya, check-in manual",
    confirm_checkout_title: "Check-out manual dari FO?",
    confirm_checkout_body:
      "Check-out biasanya dilakukan tamu sendiri di mesin selfq. Lakukan check-out manual hanya sebagai bantuan, atau bila kartu kamar sudah dikembalikan ke FO.",
    confirm_checkout_ok: "Ya, check-out manual",
    ns_title: "Deposit LUNAS — langkah berikutnya",
    ns_intro_online: "Tamu bisa langsung check-in mandiri di mesin selfq.",
    ns_intro_cash: "Berikan kwitansi deposit, lalu arahkan tamu check-in.",
    ns_step_1: "Arahkan tamu ke mesin selfq → klik “Check In”.",
    ns_step_2:
      "Tamu tempel QR (dari layar HP / instruksi check-in) ke scanner, siapkan KTP.",
    ns_step_3:
      "Ambil kartu kamar. Tunjuk mesin/poster — jangan operasikan untuk tamu.",
    ns_cash_note: "Jangan lupa berikan KWITANSI deposit ke tamu.",
    qr_tip: "Perbesar QR voucher untuk difoto lalu discan di mesin selfq",
    wa_tip:
      "Kirim link check-in cepat ke WhatsApp tamu (memuat link deposit, tanpa OTP)",
    email_edit: "Edit email",
    email_edit_tip: "Ubah email tamu",
    email_edit_desc:
      "Perbarui alamat email tamu untuk komunikasi dan Kode Rahasia refund dari Xendit.",
    email_save: "Simpan email",
    email_invalid: "Format email tidak valid.",
    phone_edit: "Edit nomor",
    phone_edit_tip: "Ubah nomor telepon / WhatsApp tamu",
    phone_edit_desc:
      "Perbarui nomor telepon / WhatsApp tamu untuk pengiriman link check-in dan refund.",
    phone_save: "Simpan nomor",
    phone_invalid: "Nomor telepon tidak valid.",
    email_ota_badge: "Email OTA",
    email_ota_tip:
      "Ini email relay OTA (mis. booking.com/agoda/traveloka). Kemungkinan besar email yang kami kirim TIDAK sampai ke tamu. Minta dan simpan email pribadi tamu.",
    badge_checkin_ready: "Siap check-in",
    badge_checkin_blocked: "Belum siap check-in",
    badge_booking_paid: "Booking lunas",
    badge_booking_unpaid: "Booking belum lunas",
    unpaid_mark: "Booking belum lunas — tarif kamar belum dibayar",
    badge_deposit_online: "Deposit online",
    badge_deposit_cash: "Deposit tunai",
    badge_deposit_unpaid: "Deposit belum dibayar",
    tb_refresh: "Refresh",
    tb_refresh_title: "Hitung mundur ke pembaruan data otomatis",
    tb_cooldown: "Cooldown",
    tb_cooldown_title:
      "Cooldown sinkronisasi ketersediaan eZee — tunggu sebelum mengubah ketersediaan lagi",
    tb_refresh_sub: "Otomatis",
    tb_cooldown_idle: "Sinkron siap",
    tb_cooldown_types: "tipe kamar",
    tb_cooldown_pop_title: "Cooldown eZee per tipe kamar",
    tb_no_rate: "Tarif belum diset",
    nav_hk: "Housekeeping",
    hk_title: "Housekeeping",
    hk_subtitle:
      "Status kebersihan semua kamar. Kamar hanya bisa check-in saat Siap.",
    mark_clean: "Tandai Siap",
    mark_dirty: "Perlu dibersihkan",
    mark_maintenance: "Perbaikan",
    nav_custom_payment: "Tagihan Bebas",
    cp_f_search: "Cari",
    cp_f_search_ph: "keterangan / nama / no. HP / email",
    cp_f_status: "Status",
    cp_f_all: "Semua",
    cp_f_from: "Dari tanggal",
    cp_f_to: "Sampai tanggal",
    cp_f_min: "Nominal min",
    cp_f_max: "Nominal maks",
    cp_f_mine: "Hanya buatan saya",
    cp_f_apply: "Terapkan",
    cp_f_clear: "Reset",
    cp_of: "dari",
    cp_title: "Tagihan Bebas (Custom Payment)",
    cp_subtitle:
      "Buat link pembayaran Xendit dengan nominal & keterangan bebas, untuk tagihan yang belum ada di sistem.",
    cp_no_refund_note:
      "Pembayaran yang sudah lunas TIDAK bisa dibatalkan dari sini. Kalau nominalnya salah dan tamu sudah bayar, refund harus lewat dashboard Xendit. Periksa nominal sebelum membuat link.",
    cp_amount: "Nominal (IDR)",
    cp_payer: "Nama pembayar",
    cp_phone: "No. WhatsApp",
    cp_email: "Email (untuk invoice)",
    cp_description: "Keterangan (tampil di invoice)",
    cp_create: "Buat link pembayaran",
    cp_needs_admin: "Nominal ini harus dibuat oleh admin",
    cp_empty: "Belum ada tagihan.",
    cp_open_link: "Buka link",
    cp_send_wa: "Kirim WA",
    cp_sync: "Sinkronkan",
    cp_recreate: "Buat ulang",
    cp_void: "Batalkan",
    cp_edit_email: "Ubah email",
    cp_invoice: "Invoice PDF",
    cp_confirm_title: "Buat tagihan ini?",
    cp_confirm_body: "Tagihan akan dibuat sebesar",
    cp_void_title: "Batalkan tagihan ini?",
    cp_void_body: "Link akan dibatalkan dan tidak bisa dibayar lagi:",
    cp_recreate_title: "Buat ulang link?",
    cp_recreate_body:
      "Link lama diganti dengan link baru. Nominal dan keterangan tetap sama.",
    cp_email_prompt: "Email untuk invoice:",
    nav_notes: "Catatan",
    nav_newbooking: "Booking Baru",
    confirm_ok: "Ya",
    confirm_generic_title: "Konfirmasi tindakan",
    check_in: "Check-in",
    check_out: "Check-out",
    full_name: "Nama lengkap",
    mdb_page_title: "Buat Booking Langsung",
    mdb_dates_title: "1. Tanggal menginap",
    mdb_load_types: "Muat tipe kamar",
    mdb_reload_types: "Muat ulang tipe",
    mdb_reset: "Reset",
    mdb_rooms_title: "2. Pilih kamar per tipe",
    mdb_room_type: "Tipe kamar",
    mdb_pick_type: "Pilih tipe...",
    mdb_qty: "Jumlah",
    mdb_add: "Tambah",
    mdb_no_items: "Belum ada tipe kamar. Tambahkan minimal satu.",
    mdb_rooms_unit: "kamar",
    mdb_status_confirmed: "Terkunci",
    mdb_status_draft: "Draf",
    mdb_remove: "Hapus",
    mdb_selected_rooms: "Kamar terpilih",
    mdb_no_rooms: "Tidak ada kamar tersedia untuk tipe & tanggal ini.",
    mdb_per_room: "kamar",
    mdb_confirm_rooms: "Konfirmasi kamar",
    mdb_extra_bed: "Extra bed",
    mdb_extra_bed_hint: "Atur per kamar, per malam.",
    mdb_extra_bed_pick_rooms:
      "Centang kamar dulu, lalu atur extra bed-nya di sini.",
    mdb_extra_bed_room: "Kamar %{code}",
    mdb_extra_bed_copy_first: "Samakan semua kamar dengan kamar pertama",
    mdb_extra_bed_none: "Tidak pakai extra bed",
    mdb_extra_bed_all: "Semua malam",
    mdb_extra_bed_clear: "Kosongkan",
    mdb_extra_bed_per_night: "%{price} / malam / kamar",
    mdb_extra_bed_total: "%{beds} bed-malam · %{total}",
    mdb_extra_bed_left: "sisa %{n}",
    mdb_extra_bed_full: "habis",
    mdb_extra_bed_unavailable:
      "Fasilitas extra bed belum dikonfigurasi. Hubungi admin.",
    mdb_confirm_rooms_title: "Konfirmasi & kunci kamar?",
    mdb_confirm_rooms_body:
      "Mengunci %{count} kamar tipe %{type} di eZee dan mengurangi ketersediaan OTA.",
    mdb_confirm_rooms_note:
      "Kamar tetap bisa dilepas lewat tombol Hapus sebelum booking dibuat.",
    mdb_confirm_rooms_ok: "Ya, kunci kamar",
    mdb_guest_title: "3. Data tamu",
    mdb_submit: "Buat booking",
    refund_send_title: "Kirim kode & link refund",
    refund_generate_title: "Buat refund online",
    refund_generate_body:
      "Refund online akan dibuat untuk semua kamar yang sudah bisa direfund. Setelah itu kode & link " +
      "dikirim ke tamu, dan payout baru diproses setelah tamu memasukkan kodenya.",
    refund_generate_ok: "Ya, buat refund",
    refund_dest_phone: "Dikirim ke nomor WhatsApp",
    refund_dest_email: "Dikirim ke email",
    refund_dest_hint:
      "Diambil dari data tamu saat ini. Kalau salah, perbaiki dulu nomor/email tamu lalu kirim ulang.",
    refund_no_destination:
      "Tamu belum punya kontak untuk saluran ini. Lengkapi dulu data tamunya.",
    refund_link_reused:
      "Link-nya sama persis setiap kali dikirim ulang, dan masa berlakunya tidak diperpanjang. " +
      "Mengirim berkali-kali tidak membuat link baru.",
    refund_attempts_budget:
      "Percobaan terpakai %{used} dari %{max}. Sisa %{left}.",
    refund_attempts_exhausted:
      "Jatah kirim habis — pakai Void & buat ulang untuk mendapat link dan jatah baru.",
    refund_cooldown: "Tunggu %{seconds} detik lagi sebelum kirim ulang.",
    refund_previous_attempts: "Riwayat pengiriman",
    refund_no_attempts: "Belum pernah dikirim.",
    refund_attempt_sent: "Terkirim",
    refund_attempt_failed: "Gagal",
    refund_actor_auto: "Otomatis",
    refund_actor_fo: "Front office",
    refund_actor_guest: "Tamu",
    refund_send_ok: "Ya, kirim sekarang",
    rf_attempts_used: "Percobaan kirim: %{used} dari %{max}",
    rf_attempts_none: "Belum pernah dikirim.",
    night_guard_warning:
      "Saat ini sudah memasuki %{date}. Hati-hati jangan salah membuat booking walk-in — " +
      "kesalahan tanggal paling sering terjadi pada tamu yang datang lewat tengah malam. " +
      "Kalau tamu datang tadi malam, pakai tanggal kemarin.",
    night_guard_ok: "Saya mengerti",
    read_aloud_title: "Bacakan ke tamu sebelum lanjut",
    read_aloud_script:
      "Baik Bapak/Ibu, izin kami konfirmasikan kembali untuk pesanannya:",
    read_aloud_guest: "Nama tamu",
    read_aloud_rooms: "Kamar",
    read_aloud_check_in: "Tanggal check-in",
    read_aloud_check_out: "Tanggal check-out",
    read_aloud_nights: "Lama menginap",
    read_aloud_nights_value: "%{nights} malam",
    read_aloud_stay: "Jenis menginap",
    read_aloud_crosses_midnight: "lewat tengah malam",
    read_aloud_transit: "Transit (per jam)",
    read_aloud_rooms_total: "Subtotal kamar",
    read_aloud_extra_beds: "Extra bed",
    read_aloud_extra_beds_value: "%{beds} bed-malam · %{total}",
    read_aloud_total: "Total",
    read_aloud_blocked: "Kamar diblokir",
    read_aloud_midnight_warning:
      "Perhatikan tanggalnya. Saat ini sudah masuk %{date}. Kalau tamu datang tadi malam, " +
      "booking ini seharusnya memakai tanggal kemarin.",
    read_aloud_back: "Kembali, ada yang salah",
    read_aloud_ok: "Sudah saya bacakan, lanjutkan",
    mdb_dates_locked_items:
      "Tanggal terkunci karena sudah ada tipe kamar di daftar. Hapus dulu item-nya kalau mau ganti tanggal.",
    mdb_dates_locked_confirmed:
      "Tanggal tidak bisa diubah setelah kamar dikunci — kamarnya sudah ditahan untuk tanggal ini. " +
      "Batalkan sesi ini dulu, lalu buat sesi baru dengan tanggal yang benar.",
    mdb_late_night_hint:
      "Sekarang sudah lewat tengah malam — hari ini %{today}. Cek lagi tanggal check-in " +
      "sebelum membuat booking walk-in.",
    mdb_use_yesterday: "Pakai tanggal kemarin",
    mdb_submit_title: "Buat booking langsung?",
    mdb_submit_body:
      "Buat SATU booking: %{rooms} kamar (%{types} tipe) untuk %{guest}, total %{total}?",
    mdb_submit_ok: "Ya, buat booking",
    mdb_blocked_badge: "Blok",
    mdb_transit_badge: "Transit",
    mdb_blocked_all: "diblokir semua malam",
    mdb_blocked_partial: "diblokir malam",
    mdb_blocked_pick_warning:
      "Anda memilih kamar yang diblokir. Blokir akan diubah menjadi reservasi saat booking dibuat.",
    mdb_submit_blocked_title: "Konfirmasi: booking termasuk kamar diblokir",
    mdb_submit_blocked_intro:
      "Booking ini memakai kamar yang sengaja diblokir:",
    mdb_submit_blocked_room: "Kamar %{code} — %{nights}",
    mdb_submit_blocked_note:
      "Yang perlu diketahui: (1) blokir kamar diubah menjadi reservasi pada malam yang dipakai; (2) ketersediaan eZee TIDAK berubah untuk malam yang diblokir; (3) blokir TIDAK otomatis kembali jika booking dibatalkan — blokir ulang manual bila perlu.",
    mdb_error_generic: "Terjadi kesalahan. Coba lagi.",
    mdb_hold_timer: "Kunci kamar (eZee)",
    mdb_hold_timer_transit: "Slot transit dikunci",
    mdb_expired:
      "Sesi kadaluarsa — kunci kamar sudah dilepas. Tekan Reset lalu mulai ulang.",
    mdb_expired_transit:
      "Sesi kadaluarsa — slot transit sudah dilepas. Tekan Reset lalu cari jam lagi.",
    mdb_dock_current: "Sesi ini",
    mdb_dock_resume: "Lanjutkan sesi",
    mdb_dock_recent: "Booking terbaru",
    mdb_resume: "Lanjutkan",
    mdb_open: "Buka",
    mdb_recent_more: "Lihat %{n}",
    mdb_recent_less: "Ringkas",
    notes_title: "Catatan Shift",
    notes_subtitle:
      "Catatan serah-terima antar shift — menampilkan hari terpilih dan sehari sebelumnya (bawaan: hari ini dan kemarin). Baca saat mulai shift.",
    note_author: "Nama Anda",
    note_body: "Tulis catatan…",
    add_note: "Tambah catatan",
    notes_empty: "Belum ada catatan.",
    notes_page: "Halaman",
    notes_prev: "Sebelumnya",
    notes_next: "Berikutnya",
    fo_comments_title: "Catatan FO",
    fo_comments_hint: "Catatan internal untuk booking ini (bukan dari tamu).",
    fo_add_placeholder: "Tulis catatan FO…",
    fo_add_btn: "Tambah",
    fo_empty: "Belum ada catatan FO.",
    fo_name_required: "Isi nama Anda dulu.",
    fo_delete: "Hapus",
    fo_checked: "Selesai",
    fo_by: "oleh",
    ota_note_title: "Catatan booking (dari tamu / OTA)",
    close: "Tutup",
    guest_email: "Email",
    guest_phone: "Telepon",
    voucher: "Voucher",
    source: "Sumber",
    source_walkin: "Hebe — walk-in / langsung",
    payout_fail_email:
      "Tamu tidak bisa mencairkan: email pada booking ditolak Xendit. Perbaiki emailnya dulu, baru buat ulang link — membuat ulang saja tidak akan menolong.",
    payout_fail_generic: "Tamu gagal membuka pencairan di halaman refund.",
    payout_fail_attempts: "%{n}x gagal",
    payout_fail_no_reason:
      "alasan tidak tercatat (percobaan sebelum perbaikan ini)",
    source_unknown: "Sumber lain",
    phone: "Telepon",
    email: "Email",
    nights: "malam",
    show_booking_note: "Lihat catatan booking",
    hide_booking_note: "Sembunyikan catatan",
    ps_availability: "Ketersediaan (kami / eZee)",
    ps_availability_hint:
      "Angka merah = ketersediaan kami berbeda dengan eZee hari ini.",
    ps_awaiting_secured: "Menunggu diamankan",
    ps_awaiting_secured_hint:
      "Kamar sudah check-out (masih kotor) dan belum diamankan HK pada tanggal terpilih. Klik untuk buka daftarnya.",
    ps_awaiting_clean: "Menunggu dibersihkan",
    ps_awaiting_clean_hint: "Kamar belum di-set bersih (vacant clean).",
    ps_rates: "Tarif kamar",
    ps_rates_hint: "Tarif walk-in per tipe kamar untuk tanggal:",
    ps_rates_simulate: "Simulasi tarif menginap",
    ps_rates_transit: "Transit (per jam)",
    resched_paid: "Sudah dibayar",
    resched_new_total: "Tarif tanggal baru",
    resched_delta_none: "Nominal sama — tidak ada selisih.",
    resched_delta_short: "Kurang bayar",
    resched_delta_collect: "tagih lewat Tagih atau Tagihan Bebas.",
    resched_delta_over: "Lebih bayar",
    resched_title: "Ubah tanggal booking",
    resched_current: "Sekarang",
    resched_becomes: "Menjadi",
    resched_new_check_in: "Check-in baru",
    resched_taken: "Dipakai",
    resched_freed: "Dilepas",
    resched_confirm: "Ya, ubah tanggal",
    resched_price_note:
      "Tarif dihitung ulang untuk malam baru — total bisa berubah bila pindah ke akhir pekan atau tanggal dengan tarif khusus.",
    act_change_dates: "Ubah tanggal",
    act_cancel_booking: "Batalkan booking",
    cancel_title: "Batalkan booking ini?",
    cancel_intro:
      "Booking dibatalkan dan semua tagihan yang belum dibayar ikut dibatalkan. " +
      "Ketersediaan kamarnya mengikuti pilihan Anda di bawah.",
    cancel_irreversible: "Tindakan ini tidak bisa dibatalkan.",
    cancel_reason_label: "Alasan pembatalan",
    cancel_reason_ph: "Contoh: tamu batal datang",
    cancel_availability_label: "Kamar ini mau diapakan setelah dibatalkan?",
    cancel_availability_release: "Jual lagi — kembalikan ketersediaan ke eZee",
    cancel_availability_release_hint:
      "Ketersediaan di eZee ditambah, kamar bisa langsung dipesan lagi lewat OTA.",
    cancel_availability_keep: "Tetap diblokir — jangan tambah ketersediaan",
    cancel_availability_transit_note:
      "Booking transit tidak memakai kuota eZee dan tidak menulis baris ketersediaan, jadi pilihan ini tidak berlaku. Pembatalan hanya melepas slot jam-nya.",
    cancel_availability_keep_hint:
      "eZee tidak diubah sama sekali dan malam-malam ini tetap diblokir sampai dibuka manual.",
    cancel_ack: "Saya sudah memastikan tamu benar-benar membatalkan.",
    cancel_confirm: "Ya, batalkan booking",
    cancel_blocked_title: "Booking ini tidak bisa dibatalkan dari sini",
    cancel_blocked_hint: "Selesaikan lewat /admin.",
    sim_title_transit: "Simulasi Tarif Transit",
    sim_mode_stay: "Menginap (per malam)",
    sim_mode_transit: "Transit (per jam)",
    sim_intro_transit:
      "Tarif transit untuk satu tanggal, per durasi yang sedang dijual.",
    sim_date: "Tanggal",
    sim_empty_transit: "Belum ada tipe kamar dengan tarif transit.",
    sim_unconfigured: "Tarif transit belum diatur untuk tipe ini.",
    sim_override: "khusus",
    sim_note_transit:
      "Tarif transit tidak memakai tarif dinamis okupansi. Deposit transit dihitung terpisah.",
    sim_title: "Simulasi Tarif Menginap",
    sim_intro:
      "Pilih tanggal check-in dan check-out untuk melihat perkiraan tarif kamar per tipe.",
    sim_check_in: "Check-in",
    sim_check_out: "Check-out",
    sim_nights: "malam",
    sim_avg: "rata-rata",
    sim_loading: "Menghitung…",
    sim_error: "Gagal menghitung tarif. Coba lagi.",
    sim_range_error: "Tanggal check-out harus setelah check-in.",
    sim_incomplete: "sebagian malam belum ada tarif",
    sim_empty: "Belum ada tipe kamar dengan tarif walk-in.",
    sim_note:
      "Perkiraan tarif walk-in untuk tanggal tersebut; belum termasuk deposit, pajak, atau diskon.",
    ps_none: "Tidak ada",
    overdue_not_checked_in: "Belum check-in (terlambat)",
    co_done: "Sudah check-out",
    fo_notes_label: "FO Notes",
    guest_notes_label: "Guest Notes",
    open_in_admin: "Buka di /admin",
    drawer_refresh: "Segarkan data booking",
    show_qr: "Tampilkan QR voucher",
    qr_hint: "Scan di mesin check-in SelfQ (atau foto lalu scan).",
    wa_voucher: "Kirim voucher via WhatsApp",
    wa_voucher_phone_prompt: "Nomor WhatsApp tamu (mis. 6281234567890):",
    wa_modal_desc: "Kirim kode voucher",
    wa_other: "Lainnya",
    wa_number_hint:
      "Kode negara terpisah. Masukkan nomor lokal tanpa 0 di depan.",
    wa_code_placeholder: "Kode negara (angka, mis. 62)",
    wa_send: "Kirim",
    wa_err_code: "Masukkan kode negara.",
    wa_err_number: "Nomor WhatsApp wajib diisi.",
    drawer_title: "Detail Booking",
    pa_collect_payment: "Tagih pembayaran booking",
    pa_collect_payment_hint:
      "Booking belum dibayar — tagih dulu sebelum deposit & check-in.",
    pa_open_admin_payment: "Booking OTA — kelola pembayaran di /admin",
    pa_check_in: "Check-in tamu",
    pa_check_out: "Check-out tamu",
    pa_refund_status:
      "Semua tamu sudah check-out. Cek status deposit & refund di bawah.",
    pa_canceled: "Booking ini dibatalkan.",
    sec_guest: "Tamu",
    sec_rooms: "Kamar",
    sec_payment: "Pembayaran",
    sec_deposit: "Deposit",
    sec_refund: "Refund Deposit",
    blk_reserved: "Status kamar bukan 'dipesan'",
    blk_confirmed: "Booking belum dikonfirmasi",
    blk_paid: "Pembayaran booking belum lunas",
    blk_deposit: "Deposit belum dibayar",
    blk_not_canceled: "Booking dibatalkan",
    blk_room_assigned: "Belum ada kamar ter-assign",
    blk_room_clean: "Kamar belum Siap (bersih)",
    blk_slot_started: "Slot transit belum dimulai",
    c_transits: "Transit hari ini",
    hk_next_transit: "Transit berikutnya",
    block_reason_label: "Alasan blokir",
    edit_block_reason: "Ubah alasan blokir",
    bulk_block: "Blokir Massal",
    bulk_block_title: "Blokir massal kamar",
    bulk_block_mode: "Aksi",
    bulk_block_from: "Dari tanggal",
    bulk_block_to: "Sampai tanggal",
    bulk_block_max_range: "Maksimal hari:",
    bulk_block_rooms: "Pilih kamar",
    bulk_block_rooms_selected: "kamar dipilih",
    bulk_block_check: "Cek dulu",
    bulk_block_ok: "Jalankan",
    bulk_block_back: "Ubah pilihan",
    bulk_block_cancel: "Batal",
    bulk_block_will_apply: "Akan diproses",
    bulk_block_skip_held: "Sudah dipesan",
    bulk_block_skip_already: "Sudah sesuai",
    bulk_block_skip_close_out: "Blokir tutup malam",
    bulk_block_nights: "malam",
    bulk_block_transit_note:
      "Ada transit di kamar ini. Malamnya tetap kosong jadi boleh diblokir, tapi tamu harian masih di dalam:",
    bulk_block_past_note:
      "Sebagian tanggal sudah lewat. Itu dicatat lokal saja — eZee tidak bisa diubah untuk tanggal yang sudah lewat.",
    bulk_block_push_note: "Satu kirim ke eZee per tipe kamar:",
    move_block: "Pindah blokir",
    move_block_title: "Pindah blokir",
    move_block_intro:
      "Pilih kamar tujuan dengan tipe yang sama. Alasan dan catatan blokir ikut pindah, dan eZee tidak diubah.",
    move_block_ok: "Pindahkan",
    move_block_confirm: "Pindahkan blokir kamar",
    move_block_none: "Tidak ada kamar lain dengan tipe yang sama.",
    move_block_selected: "Kamar tujuan",
    move_block_transit_note: "Ada jam transit terjual di kamar ini",
    move_block_source_transit_warning:
      "Kamar asal punya jam transit terjual. Setelah blokir dipindah, kamar ini bisa dipakai lagi untuk tamu menginap.",
    move_block_carrying_reason: "Alasan yang ikut pindah:",
    transit_reopen_action: "Lepas sisa jam",
    void_refund_action: "Batalkan link lama & buat baru",
    void_refund_title: "Batalkan link refund yang masih aktif?",
    void_refund_step_1:
      "Link refund yang sekarang DIBATALKAN — tamu tidak bisa memakainya lagi.",
    void_refund_step_2:
      "Link & kode rahasia BARU dibuat dengan data tamu yang sekarang.",
    void_refund_step_3:
      "Link baru dikirim ke WhatsApp tamu, kode rahasia dikirim Xendit ke email tamu.",
    void_refund_guest: "Tamu",
    void_refund_amount: "Jumlah",
    void_refund_email: "Email",
    void_refund_phone: "WhatsApp",
    void_refund_ota_warning:
      "Email ini alamat perantara OTA (Agoda/Expedia/Booking), bukan email tamu. Kode rahasia dari Xendit hampir pasti TIDAK sampai. Perbaiki email tamu dulu di atas, atau pakai email resmi hotel lalu minta manager/SPV ambil kodenya.",
    void_refund_ack:
      "Saya sudah cek email di atas benar dan bisa diterima tamu. Kalau salah, link baru pun akan gagal lagi.",
    void_refund_ok: "Ya, batalkan & buat baru",
    void_refund_cooling:
      "Link baru saja dibuat. Tunggu sebentar sebelum bisa dibatalkan lagi.",
    payout_fetch_action: "Detail payout",
    payout_fetch_title: "Detail payout Xendit",
    payout_fetch_intro:
      "Menarik status payout langsung dari Xendit dan menyimpan jawabannya apa adanya. Tidak ada uang yang dikirim atau dibatalkan di sini.",
    payout_fetch_button: "Tarik dari Xendit",
    payout_fetch_wait: "Tunggu %{seconds} dtk",
    payout_fetch_history: "Riwayat penarikan",
    payout_fetch_empty: "Belum pernah ditarik untuk refund ini.",
    payout_fetch_ok: "Berhasil",
    payout_fetch_failed: "Gagal",
    payout_fetch_by: "oleh",
    payout_fetch_show_payload: "Lihat respons mentah",
    payout_fetch_hide_payload: "Sembunyikan respons",
    payout_fetch_masked_note:
      "Nomor rekening sengaja disamarkan sebelum disimpan; sisa isi respons utuh.",
    transit_reopen_title: "Lepas sisa jam transit?",
    transit_reopen_body:
      "Sisa jam %{from}–%{to} akan dilepas dan kamar bisa dijual lagi. Pastikan kartu kamar tamu sudah diambil — kartu lama masih aktif sampai jam selesai yang dibeli.",
    transit_reopen_ok: "Ya, lepas sisa jam",
    edit_block_reason_body:
      "Kamar tetap diblokir. Alasan dan catatan ini yang dibaca shift berikutnya.",
    block_note_label: "Catatan (opsional)",
    block_note_placeholder: "mis. Persiapan transit 14:00, AC diperbaiki",
    block_reason_transit_prep: "Persiapan transit",
    block_reason_maintenance: "Perbaikan / maintenance",
    block_reason_ota_stop_sell: "Stop sell OTA",
    block_reason_owner_use: "Dipakai owner",
    block_reason_other: "Lainnya",
    // Pemakaian kamar oleh owner / relasi owner. Sengaja dieja penuh di mana-mana — singkatan
    // seperti "Comp" tidak terbaca oleh staf maupun manajemen.
    house_use_menu: "Tandai dipakai owner (house use)",
    house_use_title: "Dipakai owner — kamar",
    house_use_body:
      "Kamar ini sudah diblokir dan akan dipakai owner atau relasi owner tanpa membayar. " +
      "Menandainya membuat sistem menghitung kamar ini sebagai TERISI, bukan kosong.",
    house_use_explainer_title: "Apa yang berubah setelah ditandai",
    house_use_explainer_occupancy:
      "Okupansi terisi naik 1 kamar — inilah yang selama ini beda antara catatan manajer di lokasi dan angka yang dibaca kantor pusat.",
    house_use_explainer_revenue:
      "Kamar Terjual, pendapatan, ADR dan RevPAR TIDAK berubah sama sekali. Kamar ini terisi tetapi tidak pernah terjual.",
    house_use_explainer_payment:
      "Tidak ada tagihan, tidak ada deposit, jadi tidak ada pengembalian deposit yang perlu diurus.",
    house_use_explainer_checkout:
      "Check-out tetap seperti biasa dan housekeeping tetap menerima notifikasi untuk membersihkan kamar.",
    house_use_occupant_label: "Nama yang menginap",
    house_use_occupant_placeholder: "mis. Bpk. Hendra (owner)",
    house_use_occupant_hint:
      "Ditampilkan di Peta Kamar dan Beranda. Tidak ada email atau nomor telepon yang disimpan, jadi tamu ini tidak menerima pesan otomatis apa pun.",
    house_use_check_out_label: "Tanggal check-out",
    house_use_check_out_hint:
      "Check-in dihitung dari %{date}. Semua malam sampai tanggal check-out harus sudah diblokir lebih dulu.",
    house_use_note_label: "Catatan (opsional)",
    house_use_note_placeholder: "mis. Menginap 2 malam, izin dari GM",
    house_use_confirm: "Tandai dipakai owner",
    house_use_badge: "Dipakai owner",
    house_use_hint:
      "Kamar dipakai owner atau relasi owner. Terhitung terisi, tetapi tidak terjual: tanpa tagihan, tanpa deposit, tanpa pengembalian deposit.",
    // System-applied by the 23:40 close-out; not selectable in BlockRoomDialog.
    block_reason_nightly_close_out: "Tutup penjualan malam",
    mdb_transit_not_locked:
      "Slot ini BELUM terkunci — mulai pencarian transit baru atau batalkan sesi ini.",
    transits_today: "Transit hari ini",
    pay_paid: "Lunas",
    pay_pending: "Menunggu",
    pay_expired: "Kedaluwarsa",
    pay_failed: "Gagal",
    pay_canceled: "Dibatalkan",
    pay_unpaid: "Belum bayar",
    invoice_no: "No. Invoice",
    view_pdf: "Lihat PDF",
    download_pdf: "Unduh PDF",
    email_attention_badge: "Perhatian",
    email_attention_tip:
      "Deposit sudah dibayar via Xendit, tetapi email tamu adalah email relay OTA (booking.com/agoda/dll). Kode refund yang kami kirim ke email ini kemungkinan besar TIDAK sampai ke tamu. Minta email pribadi tamu dan perbarui di sini.",
    email_attention_short:
      "Email OTA + deposit online — kode refund mungkin tak sampai ke tamu",
    bd_deposit: "Deposit",
    sec_add_on: "Pembayaran Add-on",
    addon_title: "Add-on",
    addon_extra_bed: "Extra bed",
    addon_early: "Early check-in",
    addon_remove: "Hapus",
    pay_discount: "Diskon",
    voucher_clear: "Hapus",
    review_discount: "Diskon review",
    review_discount_used: "Diskon review sudah dipakai",
    review_discount_hint:
      "Centang hanya jika tamu benar-benar menulis review Google — verifikasi manual. Diskon berlaku untuk add-on yang memenuhi syarat, bukan tarif kamar.",
    pay_open_detail: "Lihat detail →",
    pay_detail_title: "Detail pembayaran",
    pay_kind: "Jenis",
    pay_paid_at: "Dibayar",
    pay_expires_at: "Kedaluwarsa",
    pay_sync: "Sinkronkan",
    pay_recreate: "Buat ulang link",
    pay_void: "Batalkan",
    pay_void_title: "Batalkan pembayaran ini?",
    pay_void_body:
      "Link lama tidak bisa dibayar lagi. Tagihannya kembali menjadi belum ditagih.",
    pay_back_to_charges: "Kembali ke tagihan",
    pay_title: "Tagihan booking",
    pay_subtotal: "Subtotal",
    pay_online_fee: "Biaya layanan online",
    pay_held: "Jaminan (dikembalikan)",
    pay_total: "Total ditagih",
    pay_cash: "Tandai lunas (tunai)",
    pay_link: "Buat link Xendit",
    pay_refundable: "dikembalikan",
    pay_cannot_skip: "Tidak bisa dilewati",
    pay_add: "Tambah",
    pay_add_hour: "+1 jam",
    pay_settled: "Lunas",
    pay_on_bill: "Sudah ditagih",
    pay_transit: "transit",
    pay_nothing_open: "Tidak ada tagihan terbuka.",
    pay_remove_title: "Hapus add-on ini?",
    pay_remove_body: "Add-on akan dihapus dari booking.",
    pay_unbilled: "Belum ditagih",
    pay_held_total: "Jaminan ditahan",
    pay_paid_total: "Sudah dibayar",
    pay_open: "Tagih",
    pay_open_empty: "Tambah tagihan",
    pay_no_payments: "Belum ada pembayaran.",
    cart_override_warn:
      "Di luar jam normal — tetap bisa ditambahkan oleh admin.",
    pay_state_settled: "Semua tagihan booking ini sudah lunas.",
    cart_intent_booking:
      "Booking ini BELUM dibayar — pembayaran akan mencakup kamar + deposit + tambahan ini.",
    cart_intent_deposit:
      "Deposit belum dibayar — tambahan ini ikut ditagih bersama deposit.",
    cart_intent_none:
      "Booking ini tidak bisa ditagih (dibatalkan atau belum dibayar oleh OTA).",
    addon_late_checkout: "Late check-out",
    late_paid_until: "Kartu harus diperpanjang sampai",
    late_conflict_title: "Kamar ini ada tamu masuk hari ini",
    late_conflict_ask: "Tetap jual late check-out?",
    rf_refundable: "Bisa direfund sekarang",
    rf_review: "Menunggu review",
    rf_batch: "Batch refund terakhir",
    rf_none: "Belum ada aktivitas refund.",
    rfs_not_checked_out: "Belum check-out",
    rfs_awaiting_hk: "Menunggu HK amankan kamar",
    rfs_review_cash: "Review — kamar bermasalah",
    rfs_held: "Ditahan — menunggu keputusan admin",
    rfs_refundable: "Bisa direfund (online, otomatis via WA)",
    rfs_refundable_cash: "Bisa direfund (tunai di front desk)",
    rfs_claimed: "Refund sedang diproses",
    rfs_refunded: "Refund selesai",
    rfs_kept: "Dipotong penuh (tanpa refund)",
    rfs_not_eligible: "Tidak memenuhi syarat refund",
    line_reserved: "Dipesan",
    line_checked_in: "Menginap",
    line_checked_out: "Sudah check-out",
    line_canceled: "Batal",
    wifi_label: "WiFi",
    checkin_blocked_title: "Belum bisa check-in:",
    act_send_refund_token: "Kirim kode refund (WA)",
    rf_online_status: "Status refund online",
    rf_expires: "Berlaku sampai",
    rf_send_hint:
      "Kode & link refund selalu dikirim ke kontak tamu yang terdaftar. FO tidak melihat kodenya.",
    act_generate_refund: "Buat refund online",
    rf_generate_hint:
      "Kamar sudah diamankan HK. Buat refund lalu kirim kode & link ke tamu untuk klaim online.",
    act_send_wa: "Kirim via WhatsApp",
    act_send_email: "Kirim via Email",
    act_sync_refund: "Sinkron status",
    act_regenerate_refund: "Batalkan & buat ulang",
    confirm_generate_refund_title: "Buat refund deposit online",
    confirm_generate_refund_body:
      "Membuat batch refund online untuk kamar yang sudah diamankan HK. Belum mengirim uang — hanya menyiapkan klaim.",
    confirm_generate_refund_note:
      "Setelah dibuat, kirim kode & link ke tamu (WhatsApp/email). Payout Xendit baru dibuat setelah tamu verifikasi kodenya.",
    confirm_generate_refund_ok: "Ya, buat refund online",
    rfo_pending: "Menunggu",
    rfo_payout_created: "Payout dibuat",
    rfo_whatsapp_sent: "Link terkirim",
    rfo_token_verified: "Diverifikasi tamu",
    rfo_completed: "Selesai",
    rfo_failed: "Gagal",
    rfo_expired: "Kedaluwarsa",
    rfo_canceled: "Dibatalkan",
    confirm_send_refund_title: "Kirim kode & link refund",
    confirm_send_refund_body:
      "Tamu akan menerima kode RD- dan link untuk mencairkan refund deposit secara online.",
    confirm_send_refund_note:
      "Hanya dikirim ke kontak tamu yang terdaftar (WhatsApp/email di booking). FO tidak melihat kodenya.",
    confirm_send_refund_ok: "Ya, kirim ke tamu",
    confirm_regen_refund_title: "Batalkan & buat ulang refund",
    confirm_regen_refund_body:
      "Payout lama dibatalkan di Xendit lalu dibuat payout baru, dan link/kode baru dikirim ke tamu.",
    confirm_regen_refund_note:
      "Aman: jika payout lama ternyata sudah dibayar, sistem menolak membuat ulang (cegah double-refund).",
    confirm_regen_refund_ok: "Ya, buat ulang refund",
    act_record_cash_refund: "Catat refund tunai",
    act_change_room: "Ganti kamar",
    act_swap_room: "Tukar kamar",
    act_move_room: "Pindah kamar",
    move_room_title: "Pindah kamar",
    move_room_intro:
      "Pilih kamar tujuan. Sistem menentukan sendiri caranya: pindah biasa, tukar dengan tamu di kamar itu, atau ambil kamar yang sedang diblokir.",
    move_room_ok: "Ya, pindahkan",
    move_room_mode_free: "kosong",
    move_room_mode_swap: "tukar dengan",
    move_room_mode_block: "diblokir — kamar lama akan diblokir kembali",
    move_room_transit_note: "ada transit di kamar ini",
    move_room_floor: "Lantai",
    move_room_tag_move: "Pindah",
    move_room_tag_swap: "Tukar",
    move_room_tag_block: "Blokir",
    move_room_ack_label:
      "Kamar tujuan sedang dipakai tamu menginap pada jam itu. Tetap pindahkan.",
    change_room_title: "Ganti kamar",
    change_room_current: "kamar sekarang",
    change_room_unavailable: "Tidak tersedia",
    change_room_none: "Tidak ada kamar lain yang tersedia untuk tanggal ini.",
    change_room_selected: "Terpilih",
    change_room_confirm: "Konfirmasi",
    change_room_ok: "Ya, ganti kamar",
    confirm_change_room: "Ganti kamar ke",
    swap_room_title: "Tukar kamar",
    swap_room_intro:
      "Tukar kamar tamu ini dengan booking lain (tanggal sama, belum bayar deposit, belum check-in) atau dengan kamar yang diblok pada rentang tanggal yang sama. Hanya tipe kamar yang sama yang ditampilkan.",
    swap_room_none: "Tidak ada kamar atau booking yang bisa ditukar saat ini.",
    swap_room_lines: "Booking lain (tanggal sama)",
    swap_room_blocked: "Kamar diblok (bebas diambil)",
    swap_room_same_dates: "tanggal sama",
    swap_room_free: "diblok - bebas diambil",
    swap_room_ok: "Ya, tukar kamar",
    confirm_swap_room: "Tukar kamar",
    confirm_record_cash_refund_title: "Catat refund deposit TUNAI",
    confirm_record_cash_refund_body:
      "Refund deposit kamar ini dibayar tunai. Kembalikan uang deposit langsung ke tamu.",
    confirm_record_cash_refund_note:
      "Jangan lupa terima dan cek ulang kwitansi deposit yang dikembalikan tamu, cocokkan nominalnya, lalu serahkan uangnya.",
    confirm_record_cash_refund_ok: "Ya, catat refund tunai",
    voucher_err_not_found: "Kode voucher tidak ditemukan.",
    voucher_err_redeemed: "Voucher ini sudah pernah dipakai.",
    voucher_err_void: "Voucher ini sudah dinonaktifkan admin.",
    voucher_err_batch_inactive: "Batch voucher ini sudah tidak aktif.",
    voucher_err_not_yet_valid: "Voucher ini belum berlaku.",
    voucher_err_expired: "Voucher ini sudah kedaluwarsa.",
    voucher_err_wrong_domain: "Voucher ini bukan untuk pemesanan kamar.",
    voucher_err_wrong_carrier: "Voucher hanya berlaku untuk tagihan kamar.",
    voucher_err_no_discount:
      "Voucher ini tidak memberi diskon pada tagihan kamar.",
    voucher_err_quote_unavailable:
      "Tagihan belum bisa dihitung, jadi voucher belum bisa dipakai.",
    voucher_label: "Kode voucher",
    voucher_placeholder: "Ketik kode voucher",
    voucher_apply: "Terapkan",
    voucher_applied: "Voucher berhasil dipakai.",
    provider_manual: "Manual",
    open_link: "Buka link",
    send_payment_wa: "Kirim via WhatsApp",
    confirm_send_token: "Kirim kode refund ke kontak terdaftar tamu?",
    dep_online_note:
      "Deposit yang dibayar online akan direfund secara ONLINE oleh tamu sendiri (self-service). Opsi refund muncul otomatis setelah check-out saat housekeeping menandai kamar aman — sistem mengirim WhatsApp berisi kode RD- ke tamu. FO tidak perlu memproses refund ini manual.",
    search_title: "Cari booking",
    search_placeholder: "Cari voucher / nama tamu / kamar / telepon / email…",
    adv_toggle: "Filter lanjutan",
    search_results: "Hasil Pencarian",
    search_more: "50+ hasil — persempit pencarian.",
    search_min_chars: "Ketik minimal 3 karakter untuk mencari.",
    search_typing: "Mengetik…",
    search_searching: "Mencari data…",
    search_matched: "hasil ditemukan",
    search_matched_one: "hasil ditemukan",
    search_no_match: "Tidak ada hasil yang cocok.",
    search_none: "Tidak ada booking yang cocok.",
    chip_all: "Semua",
    chip_paid: "Lunas",
    chip_canceled: "Batal",
    ls_label: "Status kamar (line)",
    ezee_label: "eZee ID",
    room_label: "No. kamar",
    ci_from: "Check-in dari",
    ci_to: "Check-in sampai",
    co_from: "Check-out dari",
    co_to: "Check-out sampai",
  },
  en: {
    app_name: "Front Desk",
    nav_rack: "Room Map",
    rack_title: "Room Map",
    rack_subtitle: "See the status of every room for the selected date.",
    view_compact: "Compact",
    view_detailed: "Detailed",
    date: "Date",
    today: "Today",
    today_current_hint: "Date filter is on today.",
    today_jump_hint: "Jump back to today.",
    building: "Building",
    all_buildings: "All buildings",
    floor: "Floor",
    legend: "Legend",
    guest: "Guest",
    open_booking: "Open booking",
    reserved: "Reserved",
    available: "Available",
    blocked: "Blocked",
    loading: "Loading…",
    empty_rooms: "No rooms for this filter.",
    error_title: "Failed to load",
    error_body: "Something went wrong. Try reloading the page.",
    retry: "Retry",
    rooms_count: "rooms",
    status_vacant_clean: "Vacant Clean",
    status_vacant_dirty: "Vacant Dirty",
    status_occupied_dirty: "Occupied Dirty",
    status_maintenance: "Maintenance",
    legend_physical: "Room status",
    legend_booking: "Date status",
    legend_activity: "Activity",
    caption_room: "Room",
    transit: "Transit",
    transit_continues: "continues tomorrow until",
    transit_continued: "continued, started yesterday",
    late_until: "Late until",
    transit_overdue: "Overdue",
    transit_crosses_midnight: "crosses midnight",
    legend_transit: "Transit (hourly stay)",
    transit_today: "Transit today",
    daypart_dini_hari: "Late night",
    daypart_pagi: "Morning",
    daypart_siang: "Midday",
    daypart_sore: "Afternoon",
    daypart_malam: "Night",
    transit_past_ended:
      "This slot already ended today. Check the hour — 21:00 is evening, 09:00 is morning.",
    transit_past_started:
      "This slot has already started. Check the hour — 21:00 is evening, 09:00 is morning.",
    transit_hours: "hours",
    caption_date: "Date",
    actions: "Actions",
    change_status: "Change room status",
    request_reopen: "Request reopen",
    confirm_reopen: "Request a reopen for this room?",
    reopen_why: "Not eligible yet:",
    reopen_ready: "Room is ready to request a reopen.",
    reopen_pick_title: "Pick reopen target",
    reopen_pick_intro:
      "More than one departed guest in this room. Pick whose nights to release back to availability.",
    reopen_nights: "nights",
    crit_has_reservation: "Has a reservation on this date",
    crit_stay_started: "Guest has checked in / out",
    crit_no_pending_reopen: "No pending reopen request",
    crit_room_still_reserved: "Room availability still active",
    status_current_hint: "Current status",
    block_room: "Block room",
    unblock_room: "Unblock room",
    confirm_block: "Block this room for the selected date?",
    confirm_unblock: "Unblock this room for the selected date?",
    nav_today: "Home",
    today_title: "Today",
    today_subtitle: "Today's operational summary.",
    c_arrivals: "Check In",
    c_departures: "Check Out",
    c_in_house: "In-house",
    c_guests: "guests staying",
    c_to_clean: "To clean",
    arrivals_today: "Check-in today",
    departures_today: "Check-out today",
    none_here: "Nothing here.",
    checkin_action: "Check-in",
    checkout_action: "Check-out",
    manual_checkin_action: "Manual check-in",
    manual_checkout_action: "Manual check-out",
    confirm_manual_checkin:
      "Perform a MANUAL check-in for this guest? Guests normally check in themselves at the SelfQ machine — use this only when actually needed.",
    confirm_manual_checkout:
      "Perform a MANUAL check-out for this guest? Check-out is normally done at the SelfQ machine — use this only when actually needed.",
    confirm_cancel: "Cancel",
    confirm_checkin_title: "Manual check-in from FO?",
    confirm_checkin_body:
      "Check-in is normally done by the guest at the selfq machine. Do a manual check-in only to help a guest who cannot use the machine.",
    confirm_checkin_ok: "Yes, manual check-in",
    confirm_checkout_title: "Manual check-out from FO?",
    confirm_checkout_body:
      "Check-out is normally done by the guest at the selfq machine. Do a manual check-out only as a help, or when the room card has been returned to the FO.",
    confirm_checkout_ok: "Yes, manual check-out",
    ns_title: "Deposit PAID — next steps",
    ns_intro_online: "The guest can self check-in at the selfq machine now.",
    ns_intro_cash:
      "Hand over the deposit receipt, then direct the guest to check in.",
    ns_step_1: "Direct the guest to the selfq machine → tap “Check In”.",
    ns_step_2:
      "Guest holds the QR (from their phone / check-in instructions) to the scanner, prepares ID.",
    ns_step_3:
      "Take the room card. Point at the machine/poster — don't operate it for the guest.",
    ns_cash_note: "Don't forget to hand the guest the deposit RECEIPT.",
    qr_tip:
      "Enlarge the voucher QR to photograph, then scan at the selfq machine",
    wa_tip:
      "Send the fast check-in link to the guest's WhatsApp (carries the deposit link, no OTP)",
    email_edit: "Edit email",
    email_edit_tip: "Change the guest email",
    email_edit_desc:
      "Update the guest's email for communication and the Xendit refund secret code.",
    email_save: "Save email",
    email_invalid: "Invalid email format.",
    phone_edit: "Edit number",
    phone_edit_tip: "Change the guest phone / WhatsApp number",
    phone_edit_desc:
      "Update the guest's phone / WhatsApp number so the check-in and refund links land.",
    phone_save: "Save number",
    phone_invalid: "Invalid phone number.",
    email_ota_badge: "OTA email",
    email_ota_tip:
      "This is an OTA relay email (e.g. booking.com/agoda/traveloka). Emails we send very likely do NOT reach the guest. Ask for and save the guest's personal email.",
    badge_checkin_ready: "Ready to check in",
    badge_checkin_blocked: "Not ready to check in",
    badge_booking_paid: "Booking paid",
    badge_booking_unpaid: "Booking unpaid",
    unpaid_mark: "Booking unpaid — the room charge has not been paid",
    badge_deposit_online: "Deposit online",
    badge_deposit_cash: "Deposit cash",
    badge_deposit_unpaid: "Deposit unpaid",
    tb_refresh: "Refresh",
    tb_refresh_title: "Countdown to the automatic data refresh",
    tb_cooldown: "Cooldown",
    tb_cooldown_title:
      "eZee availability-sync cooldown — wait before changing availability again",
    tb_refresh_sub: "Auto",
    tb_cooldown_idle: "Sync ready",
    tb_cooldown_types: "room types",
    tb_cooldown_pop_title: "eZee cooldown by room type",
    tb_no_rate: "No walk-in rate",
    nav_hk: "Housekeeping",
    hk_title: "Housekeeping",
    hk_subtitle:
      "Cleanliness status of every room. A room can only be checked in when Ready.",
    mark_clean: "Mark Ready",
    mark_dirty: "Needs cleaning",
    mark_maintenance: "Maintenance",
    nav_custom_payment: "Custom Payment",
    cp_f_search: "Search",
    cp_f_search_ph: "description / name / phone / email",
    cp_f_status: "Status",
    cp_f_all: "All",
    cp_f_from: "From date",
    cp_f_to: "To date",
    cp_f_min: "Min amount",
    cp_f_max: "Max amount",
    cp_f_mine: "Only mine",
    cp_f_apply: "Apply",
    cp_f_clear: "Reset",
    cp_of: "of",
    cp_title: "Custom Payment",
    cp_subtitle:
      "Create a Xendit payment link with a free amount and description, for charges the system does not model.",
    cp_no_refund_note:
      "A PAID payment cannot be canceled here. If the amount is wrong and the guest has already paid, the refund must go through the Xendit dashboard. Check the amount before creating the link.",
    cp_amount: "Amount (IDR)",
    cp_payer: "Payer name",
    cp_phone: "WhatsApp number",
    cp_email: "Email (for the invoice)",
    cp_description: "Description (shown on the invoice)",
    cp_create: "Create payment link",
    cp_needs_admin: "This amount must be raised by an admin",
    cp_empty: "No payments yet.",
    cp_open_link: "Open link",
    cp_send_wa: "Send WA",
    cp_sync: "Sync",
    cp_recreate: "Recreate",
    cp_void: "Cancel",
    cp_edit_email: "Edit email",
    cp_invoice: "Invoice PDF",
    cp_confirm_title: "Create this charge?",
    cp_confirm_body: "A charge will be created for",
    cp_void_title: "Cancel this charge?",
    cp_void_body: "The link will be canceled and can no longer be paid:",
    cp_recreate_title: "Recreate the link?",
    cp_recreate_body:
      "The old link is replaced by a new one. Amount and description stay the same.",
    cp_email_prompt: "Email for the invoice:",
    nav_notes: "Notes",
    nav_newbooking: "New Booking",
    confirm_ok: "Yes",
    confirm_generic_title: "Confirm action",
    check_in: "Check-in",
    check_out: "Check-out",
    full_name: "Full name",
    mdb_page_title: "Create Direct Booking",
    mdb_dates_title: "1. Stay dates",
    mdb_load_types: "Load room types",
    mdb_reload_types: "Reload types",
    mdb_reset: "Reset",
    mdb_rooms_title: "2. Pick rooms per type",
    mdb_room_type: "Room type",
    mdb_pick_type: "Pick a type...",
    mdb_qty: "Qty",
    mdb_add: "Add",
    mdb_no_items: "No room types yet. Add at least one.",
    mdb_rooms_unit: "rooms",
    mdb_status_confirmed: "Locked",
    mdb_status_draft: "Draft",
    mdb_remove: "Remove",
    mdb_selected_rooms: "Selected rooms",
    mdb_no_rooms: "No rooms available for this type & dates.",
    mdb_per_room: "room",
    mdb_confirm_rooms: "Confirm rooms",
    mdb_extra_bed: "Extra bed",
    mdb_extra_bed_hint: "Set per room, per night.",
    mdb_extra_bed_pick_rooms:
      "Tick the rooms first, then set their extra beds here.",
    mdb_extra_bed_room: "Room %{code}",
    mdb_extra_bed_copy_first: "Copy the first room to all rooms",
    mdb_extra_bed_none: "No extra bed",
    mdb_extra_bed_all: "Every night",
    mdb_extra_bed_clear: "Clear",
    mdb_extra_bed_per_night: "%{price} / night / room",
    mdb_extra_bed_total: "%{beds} bed-nights · %{total}",
    mdb_extra_bed_left: "%{n} left",
    mdb_extra_bed_full: "none left",
    mdb_extra_bed_unavailable:
      "The extra bed facility is not configured. Ask an admin.",
    mdb_confirm_rooms_title: "Confirm & hold rooms?",
    mdb_confirm_rooms_body:
      "This holds %{count} %{type} room(s) in eZee and reduces OTA availability.",
    mdb_confirm_rooms_note:
      "You can still release them with Remove before the booking is created.",
    mdb_confirm_rooms_ok: "Yes, hold rooms",
    mdb_guest_title: "3. Guest details",
    mdb_submit: "Create booking",
    refund_send_title: "Send refund code & link",
    refund_generate_title: "Create online refund",
    refund_generate_body:
      "An online refund will be created for every room that is refundable now. The code and link are " +
      "then sent to the guest, and the payout is only issued after the guest enters the code.",
    refund_generate_ok: "Yes, create refund",
    refund_dest_phone: "Sending to WhatsApp number",
    refund_dest_email: "Sending to email",
    refund_dest_hint:
      "Taken from the guest record as it is now. If it is wrong, correct the guest's contact first, then send.",
    refund_no_destination:
      "This guest has no contact for this channel yet. Complete the guest details first.",
    refund_link_reused:
      "The link is identical every time it is resent, and its expiry is not extended. Sending again " +
      "does not create a new link.",
    refund_attempts_budget: "Attempts used %{used} of %{max}. %{left} left.",
    refund_attempts_exhausted:
      "No attempts left — use Void & regenerate for a fresh link and a fresh allowance.",
    refund_cooldown: "Wait %{seconds} more seconds before resending.",
    refund_previous_attempts: "Send history",
    refund_no_attempts: "Never sent.",
    refund_attempt_sent: "Sent",
    refund_attempt_failed: "Failed",
    refund_actor_auto: "Automatic",
    refund_actor_fo: "Front office",
    refund_actor_guest: "Guest",
    refund_send_ok: "Yes, send now",
    rf_attempts_used: "Send attempts: %{used} of %{max}",
    rf_attempts_none: "Never sent.",
    night_guard_warning:
      "It is now %{date}. Take care with walk-in booking dates — the mistake happens most often " +
      "with guests arriving after midnight. If the guest arrived last night, use yesterday's date.",
    night_guard_ok: "I understand",
    read_aloud_title: "Read this to the guest before continuing",
    read_aloud_script:
      "Let me read your booking back to you to make sure it is right:",
    read_aloud_guest: "Guest name",
    read_aloud_rooms: "Rooms",
    read_aloud_check_in: "Check-in date",
    read_aloud_check_out: "Check-out date",
    read_aloud_nights: "Length of stay",
    read_aloud_nights_value: "%{nights} night(s)",
    read_aloud_stay: "Stay type",
    read_aloud_crosses_midnight: "crosses midnight",
    read_aloud_transit: "Transit (hourly)",
    read_aloud_rooms_total: "Rooms subtotal",
    read_aloud_extra_beds: "Extra bed",
    read_aloud_extra_beds_value: "%{beds} bed-nights · %{total}",
    read_aloud_total: "Total",
    read_aloud_blocked: "Blocked rooms",
    read_aloud_midnight_warning:
      "Check the date. It is already %{date}. If the guest arrived last night, this booking " +
      "should use yesterday's date.",
    read_aloud_back: "Go back, something is wrong",
    read_aloud_ok: "I have read it out, continue",
    mdb_dates_locked_items:
      "Dates are locked because room types are already in the list. Remove them first to change the dates.",
    mdb_dates_locked_confirmed:
      "Dates cannot change once rooms are locked — they are held for these dates. " +
      "Cancel this session first, then start a new one with the right dates.",
    mdb_late_night_hint:
      "It is past midnight — today is %{today}. Double-check the check-in date before creating " +
      "a walk-in booking.",
    mdb_use_yesterday: "Use yesterday's date",
    mdb_submit_title: "Create direct booking?",
    mdb_submit_body:
      "Create ONE booking: %{rooms} rooms (%{types} types) for %{guest}, total %{total}?",
    mdb_submit_ok: "Yes, create booking",
    mdb_blocked_badge: "Blocked",
    mdb_transit_badge: "Transit",
    mdb_blocked_all: "blocked all nights",
    mdb_blocked_partial: "blocked nights",
    mdb_blocked_pick_warning:
      "You picked a blocked room. The block becomes a reservation when the booking is created.",
    mdb_submit_blocked_title: "Confirm: booking includes blocked room(s)",
    mdb_submit_blocked_intro:
      "This booking uses intentionally-blocked room(s):",
    mdb_submit_blocked_room: "Room %{code} — %{nights}",
    mdb_submit_blocked_note:
      "What to know: (1) the block becomes a reservation on the booked nights; (2) eZee availability is NOT changed for blocked nights; (3) the block does NOT auto-return if the booking is canceled — re-block manually if needed.",
    mdb_error_generic: "Something went wrong. Please try again.",
    mdb_hold_timer: "Room hold (eZee)",
    mdb_hold_timer_transit: "Transit slot held",
    mdb_expired:
      "Session expired — holds have been released. Press Reset and start over.",
    mdb_expired_transit:
      "Session expired — the transit slot has been released. Press Reset and search again.",
    mdb_dock_current: "This session",
    mdb_dock_resume: "Resume session",
    mdb_dock_recent: "Recent bookings",
    mdb_resume: "Resume",
    mdb_open: "Open",
    mdb_recent_more: "Show %{n}",
    mdb_recent_less: "Less",
    notes_title: "Shift Notes",
    notes_subtitle:
      "Pass-on notes between shifts — shows the selected day and the day before (default: today and yesterday). Read at the start of your shift.",
    note_author: "Your name",
    note_body: "Write a note…",
    add_note: "Add note",
    notes_empty: "No notes yet.",
    notes_page: "Page",
    notes_prev: "Prev",
    notes_next: "Next",
    fo_comments_title: "FO Comments",
    fo_comments_hint: "Internal notes for this booking (not from the guest).",
    fo_add_placeholder: "Write an FO comment…",
    fo_add_btn: "Add",
    fo_empty: "No FO comments yet.",
    fo_name_required: "Enter your name first.",
    fo_delete: "Delete",
    fo_checked: "Done",
    fo_by: "by",
    ota_note_title: "Booking note (from guest / OTA)",
    close: "Close",
    guest_email: "Email",
    guest_phone: "Phone",
    voucher: "Voucher",
    source: "Source",
    source_walkin: "Hebe — walk-in / direct",
    payout_fail_email:
      "The guest cannot cash out: Xendit rejected the email on this booking. Fix the email first, then reissue — reissuing alone will not help.",
    payout_fail_generic:
      "The guest could not open the payout on the refund page.",
    payout_fail_attempts: "%{n} failed attempts",
    payout_fail_no_reason: "reason not recorded (attempt predates this fix)",
    source_unknown: "Other source",
    phone: "Phone",
    email: "Email",
    nights: "nights",
    show_booking_note: "Show booking note",
    hide_booking_note: "Hide note",
    ps_availability: "Availability (us / eZee)",
    ps_availability_hint: "Red = our availability differs from eZee today.",
    ps_awaiting_secured: "Awaiting secure",
    ps_awaiting_secured_hint:
      "Rooms checked out (still dirty) and not yet secured by HK on the selected date. Click to open the list.",
    ps_awaiting_clean: "Awaiting cleaning",
    ps_awaiting_clean_hint: "Rooms not yet set to clean (vacant clean).",
    ps_rates: "Room rates",
    ps_rates_hint: "Walk-in rate per room type for:",
    ps_rates_simulate: "Simulate a stay",
    ps_rates_transit: "Transit (hourly)",
    resched_paid: "Already paid",
    resched_new_total: "New dates' rate",
    resched_delta_none: "Same amount — no difference.",
    resched_delta_short: "Short by",
    resched_delta_collect: "collect it via Tagih or Tagihan Bebas.",
    resched_delta_over: "Overpaid by",
    resched_title: "Change booking dates",
    resched_current: "Currently",
    resched_becomes: "Becomes",
    resched_new_check_in: "New check-in",
    resched_taken: "Taken",
    resched_freed: "Freed",
    resched_confirm: "Yes, change the dates",
    resched_price_note:
      "The rate is re-quoted for the new nights — the total can change when moving onto a weekend or a specially-priced date.",
    act_change_dates: "Change dates",
    act_cancel_booking: "Cancel booking",
    cancel_title: "Cancel this booking?",
    cancel_intro:
      "The booking is cancelled and every unpaid charge on it is cancelled too. " +
      "What happens to the room's availability is your choice below.",
    cancel_irreversible: "This cannot be undone.",
    cancel_reason_label: "Cancellation reason",
    cancel_reason_ph: "e.g. guest did not come",
    cancel_availability_label: "What happens to this room after cancelling?",
    cancel_availability_release:
      "Sell it again — give availability back to eZee",
    cancel_availability_release_hint:
      "eZee availability goes up and the room can be booked again through the OTAs right away.",
    cancel_availability_keep: "Keep it blocked — do not add availability",
    cancel_availability_transit_note:
      "A transit booking uses no eZee inventory and writes no availability rows, so this choice does not apply. Cancelling simply releases its hour slot.",
    cancel_availability_keep_hint:
      "eZee is not touched at all and these nights stay blocked until someone unblocks them.",
    cancel_ack: "I have confirmed the guest really is cancelling.",
    cancel_confirm: "Yes, cancel the booking",
    cancel_blocked_title: "This booking cannot be cancelled here",
    cancel_blocked_hint: "Finish it in /admin.",
    sim_title_transit: "Transit Rate Simulation",
    sim_mode_stay: "Overnight (per night)",
    sim_mode_transit: "Transit (hourly)",
    sim_intro_transit:
      "Transit rates for one date, per duration currently on sale.",
    sim_date: "Date",
    sim_empty_transit: "No room type has a transit rate yet.",
    sim_unconfigured: "No transit rate configured for this type.",
    sim_override: "special",
    sim_note_transit:
      "Transit rates do not use dynamic occupancy pricing. The transit deposit is calculated separately.",
    sim_title: "Room Rate Simulation",
    sim_intro:
      "Pick check-in and check-out dates to see the estimated room charge per type.",
    sim_check_in: "Check-in",
    sim_check_out: "Check-out",
    sim_nights: "nights",
    sim_avg: "avg",
    sim_loading: "Calculating…",
    sim_error: "Could not calculate rates. Try again.",
    sim_range_error: "Check-out must be after check-in.",
    sim_incomplete: "some nights have no rate",
    sim_empty: "No room types with a walk-in rate.",
    sim_note:
      "Estimated walk-in rate for those dates; excludes deposit, tax and discounts.",
    ps_none: "None",
    overdue_not_checked_in: "Not checked in (overdue)",
    co_done: "Checked out",
    fo_notes_label: "FO Notes",
    guest_notes_label: "Guest Notes",
    open_in_admin: "Open in /admin",
    drawer_refresh: "Refresh booking data",
    show_qr: "Show voucher QR",
    qr_hint: "Scan at the SelfQ check-in machine (or photograph to scan).",
    wa_voucher: "Send voucher via WhatsApp",
    wa_voucher_phone_prompt: "Guest WhatsApp number (e.g. 6281234567890):",
    wa_modal_desc: "Send the voucher code",
    wa_other: "Other",
    wa_number_hint:
      "Country code is separate. Enter the local number without a leading zero.",
    wa_code_placeholder: "Country code (digits, e.g. 62)",
    wa_send: "Send",
    wa_err_code: "Please enter a country code.",
    wa_err_number: "WhatsApp number is required.",
    drawer_title: "Booking Detail",
    pa_collect_payment: "Collect booking payment",
    pa_collect_payment_hint:
      "Booking not paid yet — collect it before deposit & check-in.",
    pa_open_admin_payment: "OTA booking — manage payment in /admin",
    pa_check_in: "Check in guest",
    pa_check_out: "Check out guest",
    pa_refund_status:
      "All guests checked out. Review deposit & refund status below.",
    pa_canceled: "This booking is canceled.",
    sec_guest: "Guest",
    sec_rooms: "Rooms",
    sec_payment: "Payment",
    sec_deposit: "Deposit",
    sec_refund: "Deposit Refund",
    blk_reserved: "Line is not 'reserved'",
    blk_confirmed: "Booking not confirmed",
    blk_paid: "Booking payment not settled",
    blk_deposit: "Deposit not yet paid",
    blk_not_canceled: "Booking canceled",
    blk_room_assigned: "No room assigned",
    blk_room_clean: "Room not Ready (clean)",
    blk_slot_started: "Transit slot has not started",
    c_transits: "Transit today",
    hk_next_transit: "Next transit",
    block_reason_label: "Block reason",
    edit_block_reason: "Edit block reason",
    bulk_block: "Multiple Block Room",
    bulk_block_title: "Block rooms in bulk",
    bulk_block_mode: "Action",
    bulk_block_from: "From date",
    bulk_block_to: "To date",
    bulk_block_max_range: "Max days:",
    bulk_block_rooms: "Pick rooms",
    bulk_block_rooms_selected: "rooms selected",
    bulk_block_check: "Check first",
    bulk_block_ok: "Run",
    bulk_block_back: "Change selection",
    bulk_block_cancel: "Cancel",
    bulk_block_will_apply: "Will apply",
    bulk_block_skip_held: "Already booked",
    bulk_block_skip_already: "Already set",
    bulk_block_skip_close_out: "Nightly close-out block",
    bulk_block_nights: "nights",
    bulk_block_transit_note:
      "There is a transit stay in these rooms. The night itself is unsold so blocking is fine, but a day-use guest is still inside:",
    bulk_block_past_note:
      "Some dates have passed. Those are recorded locally only — eZee cannot be changed for a date in the past.",
    bulk_block_push_note: "One push to eZee per room type:",
    move_block: "Move block",
    move_block_title: "Move block",
    move_block_intro:
      "Pick a target room of the same type. The block's reason and note move with it, and eZee is not changed.",
    move_block_ok: "Move",
    move_block_confirm: "Move the block on room",
    move_block_none: "No other room of the same type.",
    move_block_selected: "Target room",
    move_block_transit_note: "This room has transit hours sold",
    move_block_source_transit_warning:
      "The source room has transit hours sold. Once the block moves, this room becomes available to overnight guests again.",
    move_block_carrying_reason: "Reason moving with it:",
    transit_reopen_action: "Release unused hours",
    void_refund_action: "Cancel old link & create new",
    void_refund_title: "Cancel the refund link that still works?",
    void_refund_step_1:
      "The current refund link is CANCELLED — the guest can no longer use it.",
    void_refund_step_2:
      "A NEW link and secret code are created from the guest's current details.",
    void_refund_step_3:
      "The new link goes to the guest's WhatsApp; Xendit emails the secret code.",
    void_refund_guest: "Guest",
    void_refund_amount: "Amount",
    void_refund_email: "Email",
    void_refund_phone: "WhatsApp",
    void_refund_ota_warning:
      "This is an OTA relay address (Agoda/Expedia/Booking), not the guest's own. The Xendit secret code almost certainly will NOT reach them. Fix the guest email above first, or use the hotel's official address and have a manager retrieve the code.",
    void_refund_ack:
      "I have checked the address above is correct and reaches the guest. If it is wrong, the new link will fail too.",
    void_refund_ok: "Yes, cancel and reissue",
    void_refund_cooling:
      "This link was just created. Wait a moment before cancelling it again.",
    payout_fetch_action: "Payout detail",
    payout_fetch_title: "Xendit payout detail",
    payout_fetch_intro:
      "Reads the payout status straight from Xendit and keeps the reply verbatim. Nothing is sent or cancelled here.",
    payout_fetch_button: "Fetch from Xendit",
    payout_fetch_wait: "Wait %{seconds}s",
    payout_fetch_history: "Fetch history",
    payout_fetch_empty: "This refund has never been fetched.",
    payout_fetch_ok: "Success",
    payout_fetch_failed: "Failed",
    payout_fetch_by: "by",
    payout_fetch_show_payload: "Show raw response",
    payout_fetch_hide_payload: "Hide response",
    payout_fetch_masked_note:
      "The account number is masked before storage on purpose; the rest of the response is intact.",
    transit_reopen_title: "Release the unused transit hours?",
    transit_reopen_body:
      "Hours %{from}–%{to} will be released and the room can be sold again. Make sure the guest's key card has been collected — the old card stays valid until the end of the window they bought.",
    transit_reopen_ok: "Yes, release them",
    edit_block_reason_body:
      "The room stays blocked. This reason and note is what the next shift reads.",
    block_note_label: "Note (optional)",
    block_note_placeholder: "e.g. Transit prep 14:00, AC repair",
    block_reason_transit_prep: "Transit preparation",
    block_reason_maintenance: "Maintenance",
    block_reason_ota_stop_sell: "OTA stop sell",
    block_reason_owner_use: "Owner use",
    block_reason_other: "Other",
    // Owner / owner-relation stay. Spelled out everywhere on purpose — an abbreviation like "Comp"
    // means nothing to the front desk or to management.
    house_use_menu: "Mark as house use (owner stay)",
    house_use_title: "House use — room",
    house_use_body:
      "This room is already blocked and will be used by the owner or an owner relation, free of charge. " +
      "Marking it makes the system count the room as OCCUPIED instead of empty.",
    house_use_explainer_title: "What changes once you mark it",
    house_use_explainer_occupancy:
      "Occupied occupancy goes up by one room — this is the gap between what the on-site manager sees and the figure head office reads.",
    house_use_explainer_revenue:
      "Rooms Sold, revenue, ADR and RevPAR do NOT change at all. The room is occupied but was never sold.",
    house_use_explainer_payment:
      "Nothing is charged and no deposit is taken, so there is no deposit refund to handle later.",
    house_use_explainer_checkout:
      "Check-out works exactly as usual, and housekeeping still gets its notification to clean the room.",
    house_use_occupant_label: "Who is staying",
    house_use_occupant_placeholder: "e.g. Mr. Hendra (owner)",
    house_use_occupant_hint:
      "Shown in Peta Kamar and Beranda. No email or phone number is stored, so this guest receives no automatic messages.",
    house_use_check_out_label: "Check-out date",
    house_use_check_out_hint:
      "Check-in is taken from %{date}. Every night up to the check-out date must already be blocked.",
    house_use_note_label: "Note (optional)",
    house_use_note_placeholder: "e.g. Two nights, approved by the GM",
    house_use_confirm: "Mark as house use",
    house_use_badge: "House use",
    house_use_hint:
      "Used by the owner or an owner relation. Counted as occupied but never as sold: nothing charged, no deposit, no deposit refund.",
    // System-applied by the 23:40 close-out; not selectable in BlockRoomDialog.
    block_reason_nightly_close_out: "Nightly sales close-out",
    mdb_transit_not_locked:
      "This slot is NOT held — start a new transit search or discard this session.",
    transits_today: "Transit today",
    pay_paid: "Paid",
    pay_pending: "Pending",
    pay_expired: "Expired",
    pay_failed: "Failed",
    pay_canceled: "Canceled",
    pay_unpaid: "Unpaid",
    invoice_no: "Invoice no.",
    view_pdf: "View PDF",
    download_pdf: "Download PDF",
    email_attention_badge: "Attention",
    email_attention_tip:
      "The deposit is paid via Xendit, but the guest email is an OTA relay address (booking.com/agoda/etc.). The refund code we email here very likely will NOT reach the guest. Ask for the guest's personal email and update it here.",
    email_attention_short:
      "OTA email + online deposit — refund code may not reach the guest",
    bd_deposit: "Deposit",
    sec_add_on: "Add-on Payment",
    addon_title: "Add-ons",
    addon_extra_bed: "Extra bed",
    addon_early: "Early check-in",
    addon_remove: "Remove",
    pay_discount: "Discount",
    voucher_clear: "Clear",
    review_discount: "Review discount",
    review_discount_used: "Review discount already used",
    review_discount_hint:
      "Tick only if the guest actually wrote a Google review — verify it manually. The discount applies to eligible add-ons, never the room charge.",
    pay_open_detail: "View detail →",
    pay_detail_title: "Payment detail",
    pay_kind: "Kind",
    pay_paid_at: "Paid",
    pay_expires_at: "Expires",
    pay_sync: "Sync",
    pay_recreate: "Recreate link",
    pay_void: "Void",
    pay_void_title: "Void this payment?",
    pay_void_body:
      "The old link can no longer be paid. Its charges go back to unbilled.",
    pay_back_to_charges: "Back to charges",
    pay_title: "Booking charges",
    pay_subtotal: "Subtotal",
    pay_online_fee: "Online service fee",
    pay_held: "Deposit (refundable)",
    pay_total: "Total to charge",
    pay_cash: "Mark paid (cash)",
    pay_link: "Create Xendit link",
    pay_refundable: "refundable",
    pay_cannot_skip: "Cannot be skipped",
    pay_add: "Add",
    pay_add_hour: "+1 hour",
    pay_settled: "Paid",
    pay_on_bill: "On a bill",
    pay_transit: "transit",
    pay_nothing_open: "Nothing outstanding.",
    pay_remove_title: "Remove this add-on?",
    pay_remove_body: "The add-on will be removed from the booking.",
    pay_unbilled: "Unbilled",
    pay_held_total: "Deposit held",
    pay_paid_total: "Paid",
    pay_open: "Charge",
    pay_open_empty: "Add a charge",
    pay_no_payments: "No payments yet.",
    cart_override_warn:
      "Outside the normal window — an admin can still add it.",
    pay_state_settled: "Everything on this booking is settled.",
    cart_intent_booking:
      "This booking is NOT paid yet — payment will cover the room + deposit + these additions.",
    cart_intent_deposit:
      "The deposit is unpaid — these additions are billed together with it.",
    cart_intent_none:
      "This booking cannot be charged (canceled, or unpaid via an OTA).",
    addon_late_checkout: "Late check-out",
    late_paid_until: "Card must be extended until",
    late_conflict_title: "This room has an arrival today",
    late_conflict_ask: "Sell late check-out anyway?",
    rf_refundable: "Refundable now",
    rf_review: "Pending review",
    rf_batch: "Latest refund batch",
    rf_none: "No refund activity yet.",
    rfs_not_checked_out: "Not checked out yet",
    rfs_awaiting_hk: "Waiting for HK to secure the room",
    rfs_review_cash: "Review — room issue",
    rfs_held: "On hold — awaiting admin decision",
    rfs_refundable: "Refundable (online, auto via WA)",
    rfs_refundable_cash: "Refundable (cash at front desk)",
    rfs_claimed: "Refund in progress",
    rfs_refunded: "Refund complete",
    rfs_kept: "Fully deducted (no refund)",
    rfs_not_eligible: "Not eligible for refund",
    line_reserved: "Reserved",
    line_checked_in: "In-house",
    line_checked_out: "Checked out",
    line_canceled: "Canceled",
    wifi_label: "WiFi",
    checkin_blocked_title: "Cannot check in yet:",
    act_send_refund_token: "Send refund code (WA)",
    rf_online_status: "Online refund status",
    rf_expires: "Valid until",
    rf_send_hint:
      "The refund code & link always go to the guest's registered contact. FO never sees the code.",
    act_generate_refund: "Generate online refund",
    rf_generate_hint:
      "HK has secured the room. Generate the refund, then send the code & link to the guest to claim online.",
    act_send_wa: "Send via WhatsApp",
    act_send_email: "Send via Email",
    act_sync_refund: "Sync status",
    act_regenerate_refund: "Cancel & regenerate",
    confirm_generate_refund_title: "Generate online deposit refund",
    confirm_generate_refund_body:
      "Creates the online refund batch for every HK-secured room. No money is sent yet — this only prepares the claim.",
    confirm_generate_refund_note:
      "After it's created, send the code & link to the guest (WhatsApp/email). The Xendit payout is issued only after the guest verifies the code.",
    confirm_generate_refund_ok: "Yes, generate online refund",
    rfo_pending: "Pending",
    rfo_payout_created: "Payout created",
    rfo_whatsapp_sent: "Link sent",
    rfo_token_verified: "Verified by guest",
    rfo_completed: "Completed",
    rfo_failed: "Failed",
    rfo_expired: "Expired",
    rfo_canceled: "Canceled",
    confirm_send_refund_title: "Send refund code & link",
    confirm_send_refund_body:
      "The guest receives their RD- code and a link to claim the deposit refund online.",
    confirm_send_refund_note:
      "Only sent to the guest's registered contact (WhatsApp/email on the booking). FO never sees the code.",
    confirm_send_refund_ok: "Yes, send to guest",
    confirm_regen_refund_title: "Cancel & regenerate refund",
    confirm_regen_refund_body:
      "The old payout is voided at Xendit, a fresh payout is created, and a new link/code is sent to the guest.",
    confirm_regen_refund_note:
      "Safe: if the old payout turns out already paid, the system refuses to regenerate (double-refund guard).",
    confirm_regen_refund_ok: "Yes, regenerate refund",
    act_record_cash_refund: "Record cash refund",
    act_change_room: "Change room",
    act_swap_room: "Swap room",
    act_move_room: "Move room",
    move_room_title: "Move room",
    move_room_intro:
      "Pick a destination. The system works out how: a plain move, a swap with the guest already there, or taking over a blocked room.",
    move_room_ok: "Yes, move",
    move_room_mode_free: "free",
    move_room_mode_swap: "swap with",
    move_room_mode_block: "blocked — the vacated room is blocked again",
    move_room_transit_note: "this room has a day-use stay",
    move_room_floor: "Floor",
    move_room_tag_move: "Move",
    move_room_tag_swap: "Swap",
    move_room_tag_block: "Block",
    move_room_ack_label:
      "An overnight guest holds the target room at those hours. Move anyway.",
    change_room_title: "Change room",
    change_room_current: "current room",
    change_room_unavailable: "Unavailable",
    change_room_none: "No other rooms available for these dates.",
    change_room_selected: "Selected",
    change_room_confirm: "Confirm",
    change_room_ok: "Yes, change room",
    confirm_change_room: "Change room to",
    swap_room_title: "Swap room",
    swap_room_intro:
      "Swap this guest's room with another booking (same dates, deposit unpaid, not checked in) or with a room blocked over the same date range. Only the same room type is shown.",
    swap_room_none: "No rooms or bookings available to swap right now.",
    swap_room_lines: "Other bookings (same dates)",
    swap_room_blocked: "Blocked rooms (free to take)",
    swap_room_same_dates: "same dates",
    swap_room_free: "blocked - free to take",
    swap_room_ok: "Yes, swap room",
    confirm_swap_room: "Swap room",
    confirm_record_cash_refund_title: "Record a CASH deposit refund",
    confirm_record_cash_refund_body:
      "This room's deposit refund is paid in cash. Return the deposit money directly to the guest.",
    confirm_record_cash_refund_note:
      "Don't forget to receive and cross-check the deposit receipt (kwitansi) the guest hands back, match the amount, then give the money.",
    confirm_record_cash_refund_ok: "Yes, record cash refund",
    voucher_err_not_found: "That voucher code was not found.",
    voucher_err_redeemed: "This voucher has already been used.",
    voucher_err_void: "This voucher was disabled by an admin.",
    voucher_err_batch_inactive: "This voucher batch is no longer active.",
    voucher_err_not_yet_valid: "This voucher is not valid yet.",
    voucher_err_expired: "This voucher has expired.",
    voucher_err_wrong_domain: "This voucher is not for room bookings.",
    voucher_err_wrong_carrier: "Vouchers only apply to the room charge.",
    voucher_err_no_discount:
      "This voucher gives no discount on the room charge.",
    voucher_err_quote_unavailable:
      "The charge cannot be calculated yet, so the voucher cannot be applied.",
    voucher_label: "Voucher code",
    voucher_placeholder: "Type a voucher code",
    voucher_apply: "Apply",
    voucher_applied: "Voucher applied.",
    provider_manual: "Manual",
    open_link: "Open link",
    send_payment_wa: "Send via WhatsApp",
    confirm_send_token:
      "Send the refund code to the guest's registered contact?",
    dep_online_note:
      "A deposit paid online is refunded ONLINE by the guest themselves (self-service). The refund option appears automatically after check-out once housekeeping marks the room secure — the system WhatsApps the guest an RD- code. FO does not process this refund manually.",
    search_title: "Find a booking",
    search_placeholder: "Search voucher / guest name / room / phone / email…",
    adv_toggle: "Advanced filters",
    search_results: "Search Results",
    search_more: "50+ results — narrow your search.",
    search_min_chars: "Type at least 3 characters to search.",
    search_typing: "Typing…",
    search_searching: "Searching…",
    search_matched: "results found",
    search_matched_one: "result found",
    search_no_match: "No matching results.",
    search_none: "No bookings match.",
    chip_all: "All",
    chip_paid: "Paid",
    chip_canceled: "Canceled",
    ls_label: "Line status",
    ezee_label: "eZee ID",
    room_label: "Room no.",
    ci_from: "Check-in from",
    ci_to: "Check-in to",
    co_from: "Check-out from",
    co_to: "Check-out to",
  },
};

const readInitialLang = () => {
  if (typeof localStorage === "undefined") {
    return "id";
  }
  const saved = localStorage.getItem("frontdesk-language");
  return saved === "en" || saved === "id" ? saved : "id";
};

const FdI18nContext = React.createContext(undefined);

export const FdI18nProvider = (props) => {
  const [lang, setLang] = React.useState(readInitialLang);

  const setLanguage = React.useCallback((next) => {
    setLang(next);
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("frontdesk-language", next);
    }
  }, []);

  const t = React.useCallback(
    (key) => STRINGS[lang]?.[key] ?? STRINGS.id[key] ?? key,
    [lang],
  );

  const value = React.useMemo(
    () => ({ lang, setLanguage, t }),
    [lang, setLanguage, t],
  );

  return <FdI18nContext value={value}>{props.children}</FdI18nContext>;
};

export const useT = () => {
  const ctx = React.use(FdI18nContext);
  if (ctx === undefined) {
    throw new Error("useT must be used within an FdI18nProvider");
  }
  return ctx;
};
